// extracted by mini-css-extract-plugin
export default {"version-picker":"version-picker___TQRRQ","item":"item___x66_e","item-selected":"item-selected___vWp2x","current-version":"current-version___OfONW"};